import React from "react";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { useSelector } from "react-redux";
import { RootState } from "../../../../libraries/state_reducers/store";
import { useDispatch } from "react-redux";
import { messageDeleteChooseAction } from "../../../../libraries/state_reducers/chats/ChatsReducer";
import { removeModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";

const ConversationDeleteConfirmAlert = () => {
  const dispatch = useDispatch();

  const messageDeleteEveryoneSelector = useSelector(
    (state: RootState) => state.chats.messageDeleteEveryone
  );

  const handleDelete = (action: "0" | "1") => {
    dispatch(messageDeleteChooseAction(action));
    dispatch(removeModal(ModalKeys.chat_delete_message));
  };

  return (
    <Listing>
      <ListItem>
        <div role="button" onClick={() => handleDelete("0")}>
          {AppTranslation.text("delete_for_me")}
        </div>
      </ListItem>
      {messageDeleteEveryoneSelector != null &&
        messageDeleteEveryoneSelector?.isEveryone && (
          <ListItem>
            <div role="button" onClick={() => handleDelete("1")}>
              {AppTranslation.text("delete_for_everyone")}
            </div>
          </ListItem>
        )}
    </Listing>
  );
};

export default ConversationDeleteConfirmAlert;
